import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

const BeneficiariesStatsPrint = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const storedFilters = localStorage.getItem('beneficiaries_stats_filters');
                let query = '';
                if (storedFilters) {
                    const filters = JSON.parse(storedFilters);
                    const params = new URLSearchParams();
                    if (filters.academic_year_id) params.append('academic_year_id', filters.academic_year_id);
                    if (filters.region_id) params.append('region_id', filters.region_id);
                    if (filters.institution_id) params.append('institution_id', filters.institution_id);
                    if (filters.school_class_id) params.append('school_class_id', filters.school_class_id);
                    if (filters.level) params.append('level', filters.level);
                    if (filters.bus_id) params.append('bus_id', filters.bus_id);
                    if (filters.gender) params.append('gender', filters.gender);
                    if (filters.group_id) params.append('group_id', filters.group_id);
                    if (filters.is_active !== undefined && filters.is_active !== '') params.append('is_active', filters.is_active);
                    if (filters.month) params.append('month', filters.month);
                    query = '?' + params.toString();
                }

                const res = await api.get(`/reports/beneficiaries-stats${query}`);
                setData(res.data);
            } catch (err) {
                console.error("Failed to load statistics:", err);
                setError('حدث خطأ أثناء جلب الإحصائيات');
            } finally {
                setLoading(false);
            }
        };

        fetchStats();
    }, []);

    useEffect(() => {
        if (!loading && data) {
            const timer = setTimeout(() => {
                window.print();
            }, 600);
            return () => clearTimeout(timer);
        }
    }, [loading, data]);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-slate-50 font-sans dir-rtl" dir="rtl">
                <div className="text-center p-8 bg-white rounded-xl shadow-sm border border-slate-200">
                    <div className="w-12 h-12 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-slate-600 font-bold">جاري تحميل تقرير إحصائيات المستفيدين...</p>
                </div>
            </div>
        );
    }

    if (error || !data) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-slate-50 font-sans dir-rtl" dir="rtl">
                <div className="text-center p-8 bg-white rounded-xl shadow-sm border border-red-200 text-red-600 font-bold">
                    {error || 'لا توجد بيانات للعرض'}
                </div>
            </div>
        );
    }

    const { meta, regions, grand_totals, gender_totals, percentages, route_totals } = data;

    // Group regions by line for display
    const linesGrouped = {};
    regions.forEach(r => {
        const l = r.line || 1;
        if (!linesGrouped[l]) linesGrouped[l] = [];
        linesGrouped[l].push(r);
    });

    const routeKeys = Object.keys(linesGrouped).sort((a, b) => Number(a) - Number(b));

    return (
        <div className="print-stats-wrapper p-4 text-slate-900 bg-white font-sans text-xs dir-rtl" dir="rtl">
            <style>{`
                @media print {
                    @page {
                        size: landscape;
                        margin: 6mm;
                    }
                    body {
                        background: #ffffff !important;
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    .no-print {
                        display: none !important;
                    }
                    .print-stats-wrapper {
                        padding: 0 !important;
                    }
                }

                .banner-title {
                    background-color: #7eb885;
                    color: #000000;
                    font-weight: 800;
                    font-size: 15px;
                    text-align: center;
                    padding: 8px 12px;
                    border: 2px solid #3d6842;
                    border-radius: 4px;
                    margin-bottom: 8px;
                }

                .stats-table {
                    width: 100%;
                    border-collapse: collapse;
                    text-align: center;
                    font-size: 11px;
                }

                .stats-table th, .stats-table td {
                    border: 1.5px solid #000000;
                    padding: 3px 2px;
                }

                .th-sec-main { background-color: #f9cb9c; font-weight: bold; }
                .th-prep-main { background-color: #c9daf8; font-weight: bold; }
                .th-sub-level { background-color: #d9ead3; font-weight: bold; font-size: 10.5px; }
                .th-total-level { background-color: #d9d2e9; font-weight: bold; }
                .th-gender { background-color: #d9ead3; font-size: 10px; }
                .th-total-grand { background-color: #d9d9d9; font-weight: bold; }

                .td-line-cell {
                    font-weight: bold;
                    background-color: #f3f3f3;
                    font-size: 12px;
                }

                .td-douar-cell {
                    font-weight: bold;
                    text-align: right;
                    padding-right: 6px !important;
                    background-color: #ffffff;
                }

                .tr-grand-total {
                    background-color: #e6e6e6;
                    font-weight: 800;
                    font-size: 12px;
                }

                .summary-card-box {
                    border: 2px solid #000000;
                    border-radius: 4px;
                    background: #ffffff;
                    text-align: center;
                }

                .summary-header {
                    background: #f3f3f3;
                    border-bottom: 1.5px solid #000000;
                    font-weight: bold;
                    padding: 4px;
                }
            `}</style>

            {/* Header Controls (No Print) */}
            <div className="no-print mb-4 flex items-center justify-between bg-slate-100 p-3 rounded-lg border border-slate-200">
                <span className="font-bold text-slate-700">معاينة طباعة إحصائيات المستفيدين</span>
                <div className="flex gap-2">
                    <button 
                        onClick={() => window.print()} 
                        className="bg-emerald-600 text-white px-4 py-2 rounded-lg font-bold hover:bg-emerald-700 transition shadow"
                    >
                        طباعة الآن
                    </button>
                    <button 
                        onClick={() => window.close()} 
                        className="bg-slate-300 text-slate-700 px-4 py-2 rounded-lg font-bold hover:bg-slate-400 transition"
                    >
                        إغلاق
                    </button>
                </div>
            </div>

            {/* Banner Title */}
            <div className="banner-title">
                إحصاء المستفيدين من النقل المدرسي بجمعية تنمية النقل المدرسي أولاد دحو حسب كل دوار 
                {meta.academic_year ? ` - الموسم الدراسي ${meta.academic_year}` : ''}
                {meta.month ? ` - شهر ${meta.month}` : ''}
                {meta.region && meta.region !== 'جميع المناطق' ? ` (${meta.region})` : ''}
                {meta.institution && meta.institution !== 'جميع المؤسسات' ? ` (${meta.institution})` : ''}
            </div>

            {/* Main Statistics Table */}
            <table className="stats-table mb-3">
                <thead>
                    <tr>
                        <th rowSpan={3} className="th-total-grand w-8">الخط</th>
                        <th rowSpan={3} className="th-total-grand" style={{ width: '130px' }}>الدوار أو المنطقة</th>
                        <th colSpan={7} className="th-sec-main">المستوى الثانوي</th>
                        <th colSpan={7} className="th-prep-main">المستوى الإعدادي</th>
                        <th rowSpan={3} className="th-total-grand" style={{ width: '65px' }}>مجموع عدد التلاميذ</th>
                    </tr>
                    <tr>
                        {/* Secondary Sub-levels */}
                        <th colSpan={2} className="th-sub-level">جذع مشترك</th>
                        <th colSpan={2} className="th-sub-level">أولى باك</th>
                        <th colSpan={2} className="th-sub-level">ثانية باك</th>
                        <th rowSpan={2} className="th-total-level" style={{ width: '38px' }}>المجموع</th>

                        {/* Middle Sub-levels */}
                        <th colSpan={2} className="th-sub-level">أولى إعدادي</th>
                        <th colSpan={2} className="th-sub-level">ثانية إعدادي</th>
                        <th colSpan={2} className="th-sub-level">ثالثة إعدادي</th>
                        <th rowSpan={2} className="th-total-level" style={{ width: '38px' }}>المجموع</th>
                    </tr>
                    <tr>
                        <th className="th-gender" style={{ width: '28px' }}>ذكور</th>
                        <th className="th-gender" style={{ width: '28px' }}>إناث</th>
                        <th className="th-gender" style={{ width: '28px' }}>ذكور</th>
                        <th className="th-gender" style={{ width: '28px' }}>إناث</th>
                        <th className="th-gender" style={{ width: '28px' }}>ذكور</th>
                        <th className="th-gender" style={{ width: '28px' }}>إناث</th>

                        <th className="th-gender" style={{ width: '28px' }}>ذكور</th>
                        <th className="th-gender" style={{ width: '28px' }}>إناث</th>
                        <th className="th-gender" style={{ width: '28px' }}>ذكور</th>
                        <th className="th-gender" style={{ width: '28px' }}>إناث</th>
                        <th className="th-gender" style={{ width: '28px' }}>ذكور</th>
                        <th className="th-gender" style={{ width: '28px' }}>إناث</th>
                    </tr>
                </thead>
                <tbody>
                    {routeKeys.map((lineNum) => {
                        const lineRegions = linesGrouped[lineNum];
                        return lineRegions.map((r, rIdx) => (
                            <tr key={`${lineNum}-${r.region_name}-${rIdx}`}>
                                {rIdx === 0 && (
                                    <td rowSpan={lineRegions.length} className="td-line-cell">
                                        {lineNum}
                                    </td>
                                )}
                                <td className="td-douar-cell">{r.region_name}</td>

                                {/* Secondary */}
                                <td>{r.sec_tc_male || ''}</td>
                                <td>{r.sec_tc_female || ''}</td>
                                <td>{r.sec_1bac_male || ''}</td>
                                <td>{r.sec_1bac_female || ''}</td>
                                <td>{r.sec_2bac_male || ''}</td>
                                <td>{r.sec_2bac_female || ''}</td>
                                <td className="font-bold bg-purple-50/50">{r.sec_total || 0}</td>

                                {/* Middle */}
                                <td>{r.prep_1_male || ''}</td>
                                <td>{r.prep_1_female || ''}</td>
                                <td>{r.prep_2_male || ''}</td>
                                <td>{r.prep_2_female || ''}</td>
                                <td>{r.prep_3_male || ''}</td>
                                <td>{r.prep_3_female || ''}</td>
                                <td className="font-bold bg-blue-50/50">{r.prep_total || 0}</td>

                                {/* Grand Row Total */}
                                <td className="font-extrabold bg-slate-100">{r.row_total}</td>
                            </tr>
                        ));
                    })}

                    {/* Grand Totals Row */}
                    <tr className="tr-grand-total">
                        <td colSpan={2}>المجموع العام</td>

                        {/* Secondary Totals */}
                        <td>{grand_totals.sec_tc_male}</td>
                        <td>{grand_totals.sec_tc_female}</td>
                        <td>{grand_totals.sec_1bac_male}</td>
                        <td>{grand_totals.sec_1bac_female}</td>
                        <td>{grand_totals.sec_2bac_male}</td>
                        <td>{grand_totals.sec_2bac_female}</td>
                        <td className="bg-purple-100">{grand_totals.sec_total}</td>

                        {/* Middle Totals */}
                        <td>{grand_totals.prep_1_male}</td>
                        <td>{grand_totals.prep_1_female}</td>
                        <td>{grand_totals.prep_2_male}</td>
                        <td>{grand_totals.prep_2_female}</td>
                        <td>{grand_totals.prep_3_male}</td>
                        <td>{grand_totals.prep_3_female}</td>
                        <td className="bg-blue-100">{grand_totals.prep_total}</td>

                        {/* Total Students */}
                        <td className="bg-gray-300 text-sm">{grand_totals.grand_total}</td>
                    </tr>
                </tbody>
            </table>

            {/* Top Summaries Row */}
            <div className="grid grid-cols-12 gap-2 mb-3">
                {/* Secondary Gender Breakdown */}
                <div className="col-span-5 border-2 border-black rounded bg-white overflow-hidden text-center text-xs">
                    <div className="grid grid-cols-4 bg-orange-100 border-b border-black font-bold p-1">
                        <div className="col-span-2 border-l border-black">مجموع عدد الذكور الثانوي</div>
                        <div className="col-span-2">مجموع عدد الإناث الثانوي</div>
                    </div>
                    <div className="grid grid-cols-4 font-extrabold p-1">
                        <div className="text-sm">{gender_totals.sec_male}</div>
                        <div className="border-l border-black text-xs pt-0.5">بنسبة {percentages.sec_male}%</div>
                        <div className="text-sm">{gender_totals.sec_female}</div>
                        <div className="text-xs pt-0.5">بنسبة {percentages.sec_female}%</div>
                    </div>
                </div>

                {/* Middle Gender Breakdown */}
                <div className="col-span-5 border-2 border-black rounded bg-white overflow-hidden text-center text-xs">
                    <div className="grid grid-cols-4 bg-blue-100 border-b border-black font-bold p-1">
                        <div className="col-span-2 border-l border-black">مجموع عدد الذكور الإعدادي</div>
                        <div className="col-span-2">مجموع عدد الإناث الإعدادي</div>
                    </div>
                    <div className="grid grid-cols-4 font-extrabold p-1">
                        <div className="text-sm">{gender_totals.prep_male}</div>
                        <div className="border-l border-black text-xs pt-0.5">بنسبة {percentages.prep_male}%</div>
                        <div className="text-sm">{gender_totals.prep_female}</div>
                        <div className="text-xs pt-0.5">بنسبة {percentages.prep_female}%</div>
                    </div>
                </div>

                {/* Overall Totals Box */}
                <div className="col-span-2 border-2 border-black rounded bg-amber-50 overflow-hidden text-center text-xs">
                    <div className="bg-amber-200 border-b border-black font-extrabold p-1 text-sm">
                        المجموع العام
                    </div>
                    <div className="p-1 font-extrabold text-base text-emerald-800">
                        {grand_totals.grand_total}
                    </div>
                </div>
            </div>

            {/* Bottom Summaries Row */}
            <div className="grid grid-cols-12 gap-2">
                {/* Route Summary Table */}
                <div className="col-span-4">
                    <table className="w-full border-2 border-black text-center text-xs">
                        <thead>
                            <tr className="bg-emerald-100 border-b-2 border-black font-bold">
                                <th className="border-r border-black p-1">رقم الخط</th>
                                <th className="border-r border-black p-1">الإعدادي</th>
                                <th className="border-r border-black p-1">الثانوي</th>
                                <th className="p-1">المجموع</th>
                            </tr>
                        </thead>
                        <tbody>
                            {route_totals.map((rt) => (
                                <tr key={rt.line} className="border-b border-black font-bold">
                                    <td className="border-r border-black bg-gray-100 p-1">{rt.line}</td>
                                    <td className="border-r border-black p-1">{rt.prep}</td>
                                    <td className="border-r border-black p-1">{rt.sec}</td>
                                    <td className="p-1 font-extrabold bg-emerald-50">{rt.total}</td>
                                </tr>
                            ))}
                            <tr className="bg-gray-200 font-extrabold text-xs">
                                <td className="border-r border-black p-1">المجموع</td>
                                <td className="border-r border-black p-1">{grand_totals.prep_total}</td>
                                <td className="border-r border-black p-1">{grand_totals.sec_total}</td>
                                <td className="p-1">{grand_totals.grand_total}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Main Overall Gender Box */}
                <div className="col-span-4 flex flex-col justify-between gap-2">
                    <div className="border-2 border-black rounded bg-emerald-50 overflow-hidden text-center flex-1 flex flex-col justify-center p-2">
                        <div className="font-bold text-sm text-slate-800 mb-1">مجموع عدد الذكور والإناث</div>
                        <div className="grid grid-cols-2 gap-2 mt-1">
                            <div className="bg-white border border-black rounded p-1">
                                <span className="block font-extrabold text-base">{gender_totals.male}</span>
                                <span className="block text-[11px] text-slate-600 font-bold">الذكور ({percentages.male}%)</span>
                            </div>
                            <div className="bg-white border border-black rounded p-1">
                                <span className="block font-extrabold text-base">{gender_totals.female}</span>
                                <span className="block text-[11px] text-slate-600 font-bold">الإناث ({percentages.female}%)</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Additional Indicators Box */}
                <div className="col-span-4">
                    <table className="w-full border-2 border-black text-center text-xs bg-white">
                        <thead>
                            <tr className="bg-slate-200 border-b-2 border-black font-bold">
                                <th colSpan={2} className="p-1">مؤشرات الحافلات والسائقين والإناث</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-b border-black">
                                <td className="border-r border-black p-1 bg-slate-50 font-bold">إناث إعدادي</td>
                                <td className="p-1 font-extrabold">{gender_totals.prep_female}</td>
                            </tr>
                            <tr className="border-b border-black">
                                <td className="border-r border-black p-1 bg-slate-50 font-bold">إناث ثانوي تأهيلي</td>
                                <td className="p-1 font-extrabold">{gender_totals.sec_female}</td>
                            </tr>
                            <tr className="border-b border-black">
                                <td className="border-r border-black p-1 bg-slate-50 font-bold">عدد السائقين المكلفين</td>
                                <td className="p-1 font-extrabold">{meta.driver_count || 0} سائقاً</td>
                            </tr>
                            <tr>
                                <td className="border-r border-black p-1 bg-slate-50 font-bold">عدد الحافلات المتوفرة حالياً</td>
                                <td className="p-1 font-extrabold">{meta.bus_count || 0} حافلة</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default BeneficiariesStatsPrint;
